// The identifying-info step's submit rules and its SSN copy, kept apart from the component so they
// can be tested without a browser.
//
// The SSN is encouraged but never required (AB#758): a blank answer books, because a household where
// nobody has a number still qualifies. Only a non-blank answer that is not 9 digits is refused.

/** The asterisk footnote. It must not read as "everything without an asterisk is optional". */
export const REQUIRED_FIELDS_FOOTNOTE =
  "Fields marked with an asterisk (*) must be filled in before you can continue. Please also enter a Social Security Number as described above.";

/** Shown under the SSN label. Asks for a number and never calls the field optional. */
export const SSN_HELPER_TEXT =
  "Enter your 9 digit social security number. If you do not have a social security number, enter that of another member of your household.";

/** Shown only in the dialog the applicant opens from the help icon beside the SSN label. */
export const SSN_DIALOG_TEXT =
  "If no one in your household has a social security number, leave this field blank. You may still qualify for assistance.";

/** Blank, or exactly 9 digits. The input strips everything but digits as the applicant types. */
export function isSsnValid(ssn: string): boolean {
  return ssn === "" || /^\d{9}$/.test(ssn);
}

export interface IdentifyingInfoInput {
  firstName: string;
  lastName: string;
  ssn: string;
  phoneValid: boolean;
  emailValid: boolean;
  dateOfBirthValid: boolean;
}

export interface IdentifyingInfoEvaluation {
  ssnValid: boolean;
  requiredFieldsFilled: boolean;
  canSubmit: boolean;
}

export function evaluateIdentifyingInfo(input: IdentifyingInfoInput): IdentifyingInfoEvaluation {
  const ssnValid = isSsnValid(input.ssn);
  const requiredFieldsFilled = input.firstName.trim() !== "" && input.lastName.trim() !== "" && input.phoneValid;
  const canSubmit = requiredFieldsFilled && input.emailValid && ssnValid && input.dateOfBirthValid;
  return { ssnValid, requiredFieldsFilled, canSubmit };
}
